import { getStatusId } from '@btime/constants'
import { gql, useMutation } from '@apollo/client'
import { useNotification } from '@btime/react-messager'

import { formatApiDate } from '../../../../../utils/helpers/date'
import { serviceOrdersClient } from '../../../../../utils/apollo/api'
import { useServiceOrder } from '../../_load/ServiceOrderLoader'

const MUTATION = gql`
  mutation InsertEvent($input: EventInput) {
    insertEvent(input: $input) {
      id
    }
  }
`

export const useSaveEvent = newStatus => {
  const serviceOrder = useServiceOrder()
  const notify = useNotification()

  const [request, state] = useMutation(MUTATION, {
    refetchQueries: ['ServiceOrders', 'ServiceOrder'],
    client: serviceOrdersClient
  })

  const handleRequest = () => {
    const input = {
      serviceOrderId: serviceOrder.id,
      statusId: getStatusId(newStatus),
      eventDate: formatApiDate(new Date())
    }

    return request({ variables: { input } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: 'Salvo com sucess!' })
      }
    })
  }

  return [handleRequest, state]
}
